'use strict';

import React from 'react';
import { createRoot } from 'react-dom/client';

import AppContext from './AppContext';
import Login from './Login/Login';
import Testimonials from './Login/Testimonials';

import routeConfig from './routeConfig';
import Error from './Error';

import { ToastContainer } from 'react-toastify';

import { ConfirmationProvider } from './helper/Confirmation';

function App({config}) {
    let path = location.pathname;

    let item = routeConfig.findLast(i => {
        let regex = new RegExp("^" + i.path + "$", "i");
       
        return regex.test(path);
    });

    if (!config) {
        config = {
            Salutations: [
                {
                    SalutationID: 1,
                    Description: "Herr",
                    Active: 1
                },
                {
                    SalutationID: 2,
                    Description: "Frau",
                    Active: 1
                }
            ],
            TypesOfSchool: [
                {
                    TypeOfSchoolID: 1,
                    Description: "Default",
                    Active: 1
                }
            ],
            Equipment: [
                {
                    EquipmentID: 1,
                    Description: "Test A",
                    Active: 1
                },
                {
                    EquipmentID: 2,
                    Description: "Test B",
                    Active: 1
                },
                {
                    EquipmentID: 3,
                    Description: "Test C",
                    Active: 1
                },
            ],
            Categories: [],
            OrganisationStatus: [],
            User: {}
        }
    }

    config.getSalutation = (id) => {
        var foundSalutation = config.Salutations.find(i => i.SalutationID == id);
        if (foundSalutation)
            return foundSalutation.Description;

        return "Herr";
    }

    config.GetOrganisationStatus = (id) => {
        var foundStatus = config.OrganisationStatus.find(i => i.StatusID == id);
        if (foundStatus)
            return foundStatus.Description;

        return "Unbekannt";
    }

    if (!item) {
        return <AppContext.Provider value={config}><Error /></AppContext.Provider>
    }
    return <AppContext.Provider value={config}>{item.component}</AppContext.Provider>;
}

function AppWrapper({config}) {
    return (
        <ConfirmationProvider>
            <App config={config} />
            <ToastContainer position="bottom-left" autoClose={5000}  />
        </ConfirmationProvider>
    );
}

let content = document.getElementById('content');
if (content) {
    let config = false;

    if (appConfig) config = appConfig;
 
    const root = createRoot(content);
    root.render(<AppWrapper config={config} />);
}

let loginContent = document.getElementById("login-content");
if (loginContent) {
    const loginRoot = createRoot(loginContent);
    loginRoot.render(<Login />);
}

let testimonials = document.getElementById("testimonials");
if (testimonials) {
    const testimonialsRoot = createRoot(testimonials);
    testimonialsRoot.render(<Testimonials />);
}